"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgImage05 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M18 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM17.766 11.955a2 2 0 0 0-1.532 0c-.371.154-.625.422-.808.648-.16.2-.333.454-.517.73L12.115 9.3c-.201-.292-.39-.563-.564-.772-.183-.22-.434-.475-.798-.623a2 2 0 0 0-1.506 0c-.364.148-.615.404-.798.623-.175.209-.363.48-.564.772L1.89 17.956c-.26.376-.493.713-.655.999-.16.284-.347.678-.325 1.14a2 2 0 0 0 .783 1.494c.367.28.796.351 1.122.381.327.03.737.03 1.194.03h16.044c.448 0 .851 0 1.174-.03.322-.03.745-.1 1.11-.375a2 2 0 0 0 .79-1.476c.027-.456-.15-.847-.304-1.132-.154-.285-.378-.62-.626-.993l-3.057-4.585a11.697 11.697 0 0 0-.567-.806c-.183-.226-.437-.494-.808-.648Z", fill: "currentColor" }) }))); };
exports.default = SvgImage05;
